import { type FC, memo } from 'react';

import SlowSectionMarker from '@/components/map/slow-section-marker';
import StationMarker from '@/components/map/station-marker';
import TrainMarker from '@/components/map/train-marker';
import VereinaInfoMarker from '@/components/map/vereina-info-marker';

const MapLayers: FC = () => {
  return (
    <>
      <SlowSectionMarker />
      <StationMarker />
      <TrainMarker />
      <VereinaInfoMarker />
    </>
  );
};

export default memo(MapLayers);
